<main>
  <section class="bg-shape-pageNotFound d-flex h100-vh align-items-center" id="pageNotFound">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-12 d-flex justify-content-center">
          <img src="../../../assets/img/logos/linhas_main_logo_black.svg" class="img-fluid logo-pageNotFound" alt="Logo Linhas - Transportes do Douro, Tâmega e Sousa">
        </div>
        <div class="col-12 mt-3">
          <h5>{{'common.error404' | translate}}</h5>
          <h4 class="color-primary">{{page404Info.Titulo_Pagina}}</h4>
          <p class="fw-700">{{page404Info.Descricao_Pagina}}</p>
          <button title="Botão ir para início" class="btn-custom btn-3 my-3" [routerLink]="'/'"><span><p class="my-auto fw-600">{{page404Info.Botao}}</p><i class="uil uil-arrow-up-right ms-2 color-white"></i></span></button>
        </div>
      </div>
    </div>
  </section>
</main>

